module.exports = __webpack_public_path__ + "static/elephant2-1b7b577f4af08fe07917d368808e1896.jpeg";